"use strict";
exports.__esModule = true;
exports.housesPower = exports.getPlanetsInfo = void 0;
var defs_1 = require("./defs");
var constants_1 = require("./constants");
var astro_utils_1 = require("./astro-utils");
var utils_1 = require("./utils");
var JonesPatterns_1 = require("./JonesPatterns");
function logger() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
}
function getPlanetsInfo(data) {
    var houseSign = {};
    for (var sign = 0; sign < 12; sign++) {
        houseSign[sign] = [];
    }
    data
        .houses
        .forEach(function (lon, i) { return houseSign[(0, astro_utils_1.getSign)(lon)].push(i); });
    var planets = {};
    var _loop_1 = function (p) {
        var controls = [];
        var houses = (0, astro_utils_1.getObjectHouses)(data.objects[p].lon, data.houses, false);
        constants_1.controllers[p]
            .forEach(function (sign) {
            return houseSign[sign]
                .forEach(function (p) { return controls.push(p); });
        });
        planets[p] = {
            significators: constants_1.significators[p],
            houses: houses,
            controls: controls
        };
    };
    for (var p = defs_1.ObjectType.Sun; p <= defs_1.ObjectType.Pluto; p++) {
        _loop_1(p);
    }
    return planets;
}
exports.getPlanetsInfo = getPlanetsInfo;
function housesPower(data) {
    logger('houses power', '-'.repeat(80));
    var power = [];
    for (var i = 0; i < 12; i++) {
        power.push(0);
    }
    var planets = getPlanetsInfo(data);
    Object
        .values(planets)
        .forEach(function (p) {
        (0, utils_1.intersection)(p.controls, p.houses)
            .forEach(function (h) { return power[h] += 3; });
        (0, utils_1.intersection)(p.significators, p.houses)
            .forEach(function (h) { return power[h] += 3; });
    });
    logger('1, 2', power);
    for (var h = 0; h < 12; h++) {
        var objects = (0, astro_utils_1.getHouseObjects)(h + defs_1.ObjectType.House1, data.houses, data.objects, false)
            .filter(function (o) { return o <= defs_1.ObjectType.Pluto; });
        if (objects.length >= 3) {
            power[h] += 3;
        }
    }
    logger('3', power);
    (0, JonesPatterns_1.getHandles)(data, [JonesPatterns_1.JonesPatternType.Basket, JonesPatterns_1.JonesPatternType.Sling]).forEach(function (p) {
        return planets[p.id]
            .houses
            .forEach(function (h) { return power[h] += 2; });
    });
    logger('4', power);
    var house1Controls = [];
    Object
        .entries(planets)
        .forEach(function (_a) {
        var k = _a[0], v = _a[1];
        if (v.controls.includes(0)) {
            house1Controls.push(+k);
        }
    });
    house1Controls
        .forEach(function (p) {
        return planets[p]
            .houses
            .forEach(function (h) { return power[h]++; });
    });
    logger('5.house_1_controls', power);
    var hpower = power
        .map(function (p, h) { return ({ p: p, h: h }); })
        .sort(function (a, b) { return (b.p - a.p) || (a.h - b.h); });
    logger('sorted', hpower);
    var h5 = hpower[4].p;
    var h6 = hpower[5].p;
    var filtered = hpower
        .filter(function (p) { return h5 === h6 ? p.p > h5 : p.p >= h5; });
    logger('filtered', filtered);
    var houses = filtered.map(function (h) { return h.h; });
    return {
        houses: houses,
        power: filtered.map(function (h) { return h.p; }),
        planets: Object
            .entries(planets)
            .map(function (_a) {
            var k = _a[0], v = _a[1];
            return ({ k: k, v: v });
        })
            .filter(function (p) { return (0, utils_1.intersection)(p.v.controls, houses).length > 0; })
            .map(function (p) { return +p.k; })
    };
}
exports.housesPower = housesPower;
